import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';

import Bs4Stores from '../../Bs4Stores'
import Bs4GenericField from './Bs4GenericField'

export default class Bs4ProgressSel extends Bs4GenericField {

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value) || null;
      if (!value) {
        value = this.bs4Store[0] || null;
      }
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.find(item => item.id == value) || null;
    }

    this.bs4Store = this.bs4Store.map((option, index) => {
      option.step = index
      return option;
    });

    this.setValue(value);
  }  

  getValueBs4 () {    
    return this.value?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  stepWidthSvg = 12;
  stepHightSvg = 35;
  stepRadius = '999px';

  ProgressStepDecorations = (props) => {
    const formField = this;

    switch (props.model) {
      case 'start':
        return (
          <Box            
            sx={{
              flex: 0,
              width: 1.5 * formField.stepWidthSvg,
              minWidth: 1.5 * formField.stepWidthSvg,
              height: '100%',
              backgroundColor: props.backgroundColor, 
              color: props.color, 
              borderRadius: `${formField.stepRadius} 0px 0px ${formField.stepRadius}`, 
            }}
          />
        );

      case 'next':
        return (
          <Box            
            sx={{
              flex: 0,
              width: 1 * formField.stepWidthSvg,
              minWidth: 1 * formField.stepWidthSvg,
              height: '100%',              
            }}
          >
            <svg 
              style={{width: formField.stepWidthSvg, height:'100%', fill: props.backgroundColor,}} 
              viewBox="0 0 17.4 57" 
              preserveAspectRatio='none'
            >
              <polygon points="1 0 0 0 0 57 1 57 17.4 28.5 1 0" />              
            </svg>          
          </Box>
        );

      case 'prev':
        return (
          <Box            
            sx={{
              width: 1 * formField.stepWidthSvg,
              minWidth: 1 * formField.stepWidthSvg,
              height: '100%',
              overflow: 'visible'
            }}
          >
            <svg 
              style={{width: formField.stepWidthSvg, height:'100%', fill: props.backgroundColor}} 
              viewBox="0 0 17.4 57" 
              preserveAspectRatio='none'
            >              
              <polygon points="0 0 16.5 28.5 0 57 17.2 57 17.2 0 0 0"/> 
            </svg>          
          </Box>
        );

      case 'end':
        return (
          <Box            
            sx={{
              flex: 0,
              width: 1.5 * formField.stepWidthSvg,
              minWidth: 1.5 * formField.stepWidthSvg,
              height: '100%',
              backgroundColor: props.backgroundColor, 
              color: props.color, 
              borderRadius: `0px ${formField.stepRadius} ${formField.stepRadius} 0px`, 
            }}
          />
        );

      default: 
        return null;
    }
  }

  ProgressStep = (props) => {
    const formField = this;
    const theme = useTheme();

    let color = theme.palette.primary.main
    let backgroundColor = lighten(theme.palette.primary.main, 0.8);

    if (props.completed) {
      backgroundColor = theme.palette.primary.main
      color = lighten(theme.palette.primary.main, 0.8);
    }

    return (
      <Stack 
        direction='row' 
        sx={{flex: 1, justifyContent: "flex-start", alignItems:"center", height: formField.stepHightSvg, overflow: 'hidden', marginLeft: -0.37, marginRight: -0.37}}
      > 
        <formField.ProgressStepDecorations model={props.first ? 'start' : 'prev'} backgroundColor={backgroundColor} color={color}/>
        <Bs4Tooltip arrow title={
          <React.Fragment>
            <Typography variant='body1' sx={{whiteSpace: 'pre-line'}}>{props.option.name}</Typography>
            <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{props.option.text}</Typography>
          </React.Fragment>
        }>                              
          <ButtonBase 
            sx={{flex: 1, m:0, height: '100%', backgroundColor: backgroundColor, color: color, overflow: 'hidden',}} 
            onClick={(event) => props.onClick(event, props.option)}
          >
            {props?.option?.icon && <Box className={props?.option?.icon}>&nbsp;&nbsp;</Box>}
            <Typography 
              sx={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'calc(100% - 1px)',}}
            >
              {props.option.name}
            </Typography>
          </ButtonBase>
        </Bs4Tooltip>     
        <formField.ProgressStepDecorations model={props.last ? 'end' : 'next'} backgroundColor={backgroundColor} color={color}/>
      </Stack> 
    );
  }

  ViewComponentField = (props) => {
    const formField = this;        
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR) 
    const [value, setValue] = React.useState(this.getValue());
    const [bs4Store, setBs4Store] = React.useState(formField.bs4Store || []);
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {        
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);

      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      };
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE)

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error, value, setError, setValue, setBs4Store]);

    const getCompleted = (option) => {
      if (!option || !value) return false;
      return option.step <= value.step;
    }

    const handleStep = (event, option) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(option);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);      
    }
        
    const length = bs4Store.length;

    return (
      <FormControl fullWidth  error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Stack ref={this.refFocus} direction="row" sx={{justifyContent: "flex-start", alignItems: "center",  flexWrap: 'nowrap'}}>
          {bs4Store.map((option, index) => {
            return (
            <formField.ProgressStep key={option.id} option={option} first={index === 0} last={index === length - 1} completed={getCompleted(option)} onClick={handleStep}/>
          )})}
        </Stack>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}